import Vue from "vue";
import Router from "vue-router";
import store from "../store";

// Root Pages
import WelcomePage from "@/views/Welcome";
import ViewPage from "@/views/View";
import HomePage from "@/views/Home";
import ProfilePage from "@/views/Profile";
import FAQPage from "@/views/FAQ";
import PrefPage from "@/views/Communications";
import HelpPage from "@/views/Help";
import LinksPage from "@/views/Links";
import SvcRequestPage from "@/views/SvcRequest";
import Invites from "@/views/Invites";
import Invite from "@/views/Invite";
import Appoint from "@/views/Appointment";
import Correspond from "@/views/Correspondence";
import Agents from "@/views/Agents";
import AgentDetail from "@/views/Agent";
import Wizard from "@/views/Wizard";
import NotFoundComponent from "@/views/NotFound";
import InProgress from "@/views/InProgress";
import Reports from "@/views/Reports";

Vue.use(Router);

let router = new Router({
   mode: "history",
   base: process.env.BASE_URL,
   routes: [
      {
         path: "/",
         name: "welcome",
         component: WelcomePage,
         meta: { requiresAuth: false, title: "Welcome", layout: "anon" }
      },
      {
         path: "/home",
         name: "home",
         component: HomePage,
         meta: { requiresAuth: true, title: "Home Page" }
      },
      {
         path: "/profile",
         name: "profile",
         component: ProfilePage,
         meta: { requiresAuth: true, title: "Profile Page" }
      },
      {
         path: "/faq",
         name: "faq",
         component: FAQPage,
         meta: { requiresAuth: true, title: "Frequently Asked Questions Page" }
      },
      {
         path: "/commpref",
         name: "commpref",
         component: PrefPage,
         meta: { requiresAuth: true, title: "Communication Preferences" }
      },
      {
         path: "/help",
         name: "help",
         component: HelpPage,
         meta: { requiresAuth: true, title: "Help" }
      },
      {
         path: "/invite",
         name: "invite",
         component: Invite,
         meta: { requiresAuth: true, title: "Send an Invite" }
      },
      {
         path: "/invites",
         name: "invites",
         component: Invites,
         meta: { requiresAuth: true, title: "Invitations" }
      },
      {
         path: "/agents",
         name: "agents",
         component: Agents,
         meta: { requiresAuth: true, title: "Agents" }
      },
      {
         path: "/agent",
         name: "agent",
         component: AgentDetail,
         meta: { requiresAuth: true, title: "Agent Detail" }
      },
      {
         path: "/corr",
         name: "corr",
         component: Correspond,
         meta: { requiresAuth: true, title: "Email Templates" }
      },
      {
         path: "/reports",
         name: "reports",
         component: Reports,
         meta: { requiresAuth: true, title: "Reports" }
      },
      {
         path: "/appoint",
         name: "appoint",
         component: Appoint,
         meta: { requiresAuth: true, title: "Appointment Details" }
      },
      {
         path: "/inprog",
         name: "inprog",
         component: InProgress,
         meta: { requiresAuth: true, title: "Applications In-Progress" }
      },
      {
         path: "/linx",
         name: "linx",
         component: LinksPage,
         meta: { requiresAuth: true, title: "Appointment Links" }
      },
      {
         path: "/cartlinks",
         name: "cartlinks",
         component: LinksPage,
         meta: { requiresAuth: true, title: "Appointment Links" }
      },
      {
         path: "/wizard",
         name: "wizard",
         component: Wizard,
         meta: { requiresAuth: true, title: "New Appointment Application" }
      },
      {
         path: "/svcreq/:typ?",
         name: "svcreq",
         component: SvcRequestPage,
         meta: { requiresAuth: true, title: "Contact Us" }
      },
      {
         path: "/view/:pth",
         name: "view",
         component: ViewPage,
         meta: { requiresAuth: false, title: "Download", layout: "anon" }
      },
      {
         path: "/:lnk",
         name: "welcomelink",
         component: WelcomePage,
         meta: { requiresAuth: false, title: "Welcome", layout: "anon" }
      },
      {
         path: "/:catchAll(.*)",
         name: "NotFound",
         component: NotFoundComponent,
         meta: { requiresAuth: false, title: "Oops!", layout: "anon" }
      }
   ],
   linkExactActiveClass: "active",
   scrollBehavior(to, from, savedPosition) {
      return { x: 0, y: 0 };
   }
});

router.beforeEach(async (to, from, next) => {
   const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
   const isAuthenticated = await Vue.prototype.$auth.isAuthenticated();

   if (requiresAuth && !isAuthenticated) {
      next(false);
      await Vue.prototype.$auth.login(to.path);
   } else {
      next();
   }
});

export default router;
